import React from 'react';
export const colDescription = {
  classes: "w-30",
  dataField: "description",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return <div className={"test-column-description"}>{col}</div>;
  },
  text: "Description",
};
